// IMPORT VUETIFY and its css
import Vue from "vue";
import Vuetify from "vuetify/lib";
import 'vuetify/dist/vuetify.min.css';
// IMPORT ICONS
import "material-design-icons-iconfont/dist/material-design-icons.css"; // md: Ensure you are using css-loader
import "@mdi/font/css/materialdesignicons.css"; // mdi: Ensure you are using css-loader
import "@fortawesome/fontawesome-free/css/all.css"; // fa5: Ensure you are using css-loader
import { Ripple } from 'vuetify/lib/directives'

// IMPORT internationalization for Vuetify
import i18n from "@/plugins/i18n.js";      // intenationalization

Vue.use(Vuetify, {
    directives: {
        Ripple
    },

    theme: {
        primary: "#0548b5",
        secondary: "#424242",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
    },
    customProperties: true,
    iconfont: "fa" || "md" || "mdi",
    /*lang: {
        t: (key, ...params) => i18n.t(key, params), // TODO - STUDY https://vuetifyjs.com/en/framework/internationalization
    },*/
    // RLT - Support for right-to-left languages.
    // Change with $vuetify.rlt = <boolValue> when a rtl language is used. If true invert the text alignment (from right)
    rtl: false,
});
